import styled from 'styled-components';

const StyledPrivateSale = styled.section`
    max-width: 1440px;
    padding: 50px 40px;

    h1 {
        font-size: 36px;
        font-weight: 700;
        line-height: 44px;
        margin-bottom: 20px;
        text-align: center;
        text-transform: uppercase;
    }

    .distributionAllocationTypes {
        padding: 15px 50px;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: right 1rem center;
        background-size: 1em;

        border-radius: var(--borderRadiusSm);
        border: 1px solid var(--brand);
        color: var(--brand);
        font-weight: 600;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: 0.02em;
        display: flex;
        align-items: center;
        gap: 15px;
        cursor: pointer;
        transition: 0.3s all;

        &:hover {
            opacity: 0.6;
        }

        .copy-button {
            line-height: 1;
        }
    }

    .allocation-type-dropdown {
        width: max-content;
        margin: auto;
        margin-bottom: 40px;

        .dropdown-container {
            width: 100%;

            li {
                text-transform: uppercase;

                &.active {
                    background: #d3d3d359;
                }
            }
        }
    }
`;

export default StyledPrivateSale;
